import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/common/loader.service';
import { MasterService } from '../master.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-area-levels',
  templateUrl: './area-levels.component.html',
  styleUrls: ['./area-levels.component.scss']
})
export class AreaLevelsComponent implements OnInit {
  geographyForm: FormGroup;
  saveData={};
  shName;
  countryList:any[];
  area1List:any[];
  area2List:any[];
  area3List:any[];
  area4List:any[];
  searchCriteria={};
  constructor(private formBuilder: FormBuilder,private masterService: MasterService,private route: ActivatedRoute,private loaderService:LoaderService,private toasterService: ToastrService, private router: Router) { 
    this.route.queryParams.subscribe(param =>{
      this.shName=param.masterShName;
      this.loadMasterData();
    });
    this.getGeographyForm();
  }

  ngOnInit() {
  }
  get f() {
    return this.geographyForm.controls;
  }
  loadMasterData(){
    //Country
    this.searchCriteria={
      masterShName:'COUNTRY',
      master:{}
    }
    this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
      this.countryList= response['result'];
    })
  }
  private getGeographyForm() {
    this.geographyForm = this.formBuilder.group({
      'id':[],
      'codeInternational': new FormControl(),
      'codeLocal': new FormControl(),
      'code': new FormControl(),
      'description': new FormControl(),
      'descriptionFr': new FormControl(),
      'cotryVaNationalityEn': new FormControl(),
      'contiCode': new FormControl(),
      'ctareCode': new FormControl(),
      'latitude': new FormControl(),
      'longitude': new FormControl(),
      'cotryId': new FormControl(),
      'area1Id': new FormControl(),
      'area2Id': new FormControl(),
      'area3Id': new FormControl(),
      'area4Id': new FormControl(),
      'postalCode': new FormControl()
    })
  }
  saveMaster(){
    /* this.submitted = true;
    if (this.logisticsForm.invalid) {
      return;
    } */
    this.prepareSaveForm(this.shName);
    this.loaderService.display(true);
    this.masterService.saveMaster(this.saveData).subscribe(response => {
      this.loaderService.display(false);
      if (response && response["code"]==0) {
        this.toasterService.success(response['message'], 'Success');
      }else{
        this.toasterService.error(response['message'], 'Error');
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  prepareSaveForm(shName){
        let masterIp={
          id:this.f.id.value,
          code:this.f.code.value,
          codeInternational:this.f.codeInternational.value,
          codeLocal:this.f.codeLocal.value,
          descriptionFr:this.f.descriptionFr.value,
          description:this.f.description.value,
          contiCode:this.f.contiCode.value,
          ctareCode:this.f.ctareCode.value
        }
        if(shName=='COUNTRY'){
          masterIp['cotryVaNationalityEn']=this.f.cotryVaNationalityEn.value
        }
        if(shName!='COUNTRY'){
          masterIp['latitude']=this.f.latitude.value,
          masterIp['longitude']=this.f.longitude.value,
          //if(shName=='TOWN' || shName=='AREALEVEL1'){
            masterIp['cotryId']=this.f.cotryId.value
          //}
          
        }
        if(shName=='TOWN'){
          masterIp['area1Id']=this.f.area1Id.value,
          masterIp['area2Id']=this.f.area2Id.value,
          masterIp['area3Id']=this.f.area3Id.value       
          masterIp['area4Id']=this.f.area4Id.value,
          masterIp['townVaPostalCode']=this.f.postalCode.value
        }else if(shName=='AREALEVEL4'){
          masterIp['area3Id']=this.f.area3Id.value
        }else if(shName=='AREALEVEL3'){
          masterIp['area2Id']=this.f.area2Id.value
        }else if(shName=='AREALEVEL2'){
          masterIp['area1Id']=this.f.area1Id.value
        }
        
        this.saveData={
          masterShName:shName,
          master:masterIp
        }
    
  }
  backToList(){   
    if(this.shName=='COUNTRY'){   
      this.router.navigateByUrl('/country?masterShName=COUNTRY');
    }
    if(this.shName=='TOWN'){
      this.router.navigateByUrl('/areaLevels?masterShName=TOWN');
    }
    if(this.shName=='AREALEVEL1'){
      this.router.navigateByUrl('/arealevel1?masterShName=AREALEVEL1');
    }
    if(this.shName=='AREALEVEL2'){
      this.router.navigateByUrl('/arealevel2?masterShName=AREALEVEL2');
    }
    if(this.shName=='AREALEVEL3'){
      this.router.navigateByUrl('/arealevel3?masterShName=AREALEVEL3');
    }
    if(this.shName=='AREALEVEL4'){
      this.router.navigateByUrl('/arealevel4?masterShName=AREALEVEL4');
    }
  }
  patchFormValues(result,shName){
        this.loadArea1(result.cotryId);
        this.loadArea2(result.area1Id);
        this.loadArea3(result.area2Id);
        this.loadArea4(result.area3Id);
        this.geographyForm.patchValue({
          codeInternational:result["codeInternational"],
          codeLocal:result["codeLocal"],
          code:result["code"],
          cotryCode:result["cotryCode"],
          description:result["description"],
          descriptionFr:result["descriptionFr"],
          cotryVaNationalityEn:result["cotryVaNationalityEn"],
          contiCode:result["contiCode"],
          ctareCode:result["ctareCode"],
          latitude:result["latitude"],
          longitude:result["longitude"],
          postalCode:result["townVaPostalCode"],
          cotryId:result["cotryId"],
          area1Id:result["area1Id"],
          area2Id:result["area2Id"],
          area3Id:result["area3Id"],
          area4Id:result["area4Id"],
          id:result["id"]});
  }
  reset(){
    this.geographyForm.reset();
  }
  loadArea1(id){
    //AREALEVEL1
    this.searchCriteria={
     masterShName:'AREALEVEL1',
     master:{cotryId:id}
   }
   this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
     this.area1List= response['result'];
   })
 }
 
 loadArea2(id){
   //AREALEVEL1
   this.searchCriteria={
    masterShName:'AREALEVEL2',
    master:{area1Id:id}
  }
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
    this.area2List= response['result'];
  })
 }
 
 loadArea3(id){
   //AREALEVEL1
   this.searchCriteria={
    masterShName:'AREALEVEL3',
    master:{area2Id:id}
  }
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
    this.area3List= response['result'];
  })
 }
 
 loadArea4(id){
   //AREALEVEL1
   this.searchCriteria={
    masterShName:'AREALEVEL4',
    master:{area3Id:id}
  }
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
    this.area4List= response['result'];
  })
 }
}
